var path = '/user/manage-plan/manage-plan.html';
var html = "<user-details-tabs></user-details-tabs> <md-card class=\"card-user-account manage-plan\" user-can=view_plan> <div ng-include=\"'/user/visionapi/vision-api-upgrade-card.html'\" ng-controller=\"VisionApiUpgradeCtrl as cvapi\"> </div> </md-card> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./user/manage-plan/manage-plan.html
// module id = 121
// module chunks = 0